import React, { Suspense } from "react";

import ComponentLoader from "@performyard/py-components/src/components/atoms/ComponentLoader";

import Config from "./Config";
import { ReviewCycleCreateRouter } from "./ReviewCycleCreate";

import { useCurrentRouteProps } from "../../../app/router";

import { useFeatureFlagQuery } from "../../../hooks/useFeatureFlag";
import { useHideSubNav } from "../../../hooks/useHideSubNav";

const LazyCreateReviewCycle = React.lazy(() => import("./createReviewCycle"));

const LegacyCreateReviewCycle = () => {
	const routeProps = useCurrentRouteProps();
	const [finishedSetup, setFinishedSetup] = React.useState(false);

	React.useEffect(() => {
		Config.pageName = routeProps.pageName;
		setFinishedSetup(true);
	}, [routeProps.pageName]);

	if (!finishedSetup) {
		return <ComponentLoader />;
	}

	return (
		<Suspense fallback={<ComponentLoader />}>
			<LazyCreateReviewCycle />
		</Suspense>
	);
};

const CreateReviewCyclePage = () => {
	const { value: hasReviewCycleRefresh, query } = useFeatureFlagQuery<boolean>(
		"ff-temp-has-review-cycle-refresh",
		false
	);

	useHideSubNav(hasReviewCycleRefresh);

	if (query.isLoading) {
		return <ComponentLoader />;
	}

	if (hasReviewCycleRefresh) {
		return <ReviewCycleCreateRouter />;
	}

	return <LegacyCreateReviewCycle />;
};

export default CreateReviewCyclePage;
